module.exports = __webpack_public_path__ + "img/up11.d9168970.png";